import React from 'react';
import { Popover, Button, message } from 'antd';
import dayjs from 'utils/dayjs';
import { TPaymentBilling } from 'types/provider';
import { sendMessage } from 'api/inbox';
import s from './s.module.less';
import ProviderStore from 'store/Provider';
import { getHelloKlarityHost } from 'utils/common';
interface InvoiceReminderBtnProps {
    item: TPaymentBilling;
    asButton?: boolean; // 控制是否显示为按钮样式
}

const InvoiceReminderBtn: React.FC<InvoiceReminderBtnProps> = ({ item, asButton = false }) => {
    const [getUser] = ProviderStore.useStore();
    const user = getUser('data');

    const providerName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || '{{Provider Name}}';
    const patientName = `${item.patientFirstName || ''} ${item.patientLastName || ''}`.trim() || '[Patient\'s Name]';
    const totalAmount = item.amountCents ? `$${((item.amountCents || 0) / 100).toFixed(2)}` : '${{Total Amount}}';
    const dueDate = item.dueDate ? dayjs(item.dueDate).format('MM/DD/YYYY') : '';
    const invoiceUrl = `${getHelloKlarityHost()}/invoice/${item.invoiceNo}`;

    const renderInvoiceReminderPreview = () => {
        return (
            <div className={s.invoiceReminderPreview}>
                <div className={s.invoiceReminderPreviewHeader}>
                    <div className={s.invoiceReminderPreviewTitle}>📩 Invoice reminder message preview</div>
                </div>
                <div className={s.invoiceReminderPreviewContent}>
                    <div>
                        <div className={s.invoiceReminderPreviewText}>Hi {patientName},</div>
                        <div className={s.invoiceReminderPreviewText}>Just a quick reminder to review and pay your invoice.</div>
                    </div>
                    <div>
                        <div className={s.invoiceReminderPreviewTitle}>Invoice details</div>
                        <div className={s.invoiceReminderPreviewText}>Amount due: {totalAmount}</div>
                        {dueDate && <div className={s.invoiceReminderPreviewText}>Due date: {dueDate}</div>}
                    </div>
                    <div className={s.invoiceReminderPreviewLink}>
                        👉 Pay invoice now
                    </div>
                    <div className={s.invoiceReminderPreviewText}>
                        If you have any questions or need clarification, feel free to reach out. I'm happy to help.
                    </div>
                    <div className={s.invoiceReminderPreviewText}>
                        <div>Thank you,</div>
                        <div>{providerName}</div>
                    </div>
                </div>
            </div>
        );
    };

    const handleSendReminder = async () => {
        const reminderMessage = `Hi ${patientName},

        Just a quick reminder to review and pay your invoice.

        <b>Invoice details</b>
        Amount due: ${totalAmount}
        Due date: ${dueDate}

        👉 Pay invoice now: ${invoiceUrl}

        If you have any questions or need clarification, feel free to reach out. I'm happy to help.

        Thank you,
        ${providerName}`;

        try {
            const res = await sendMessage({
                providerId: user?.id!,
                clientId: item.clientId!,
                message: reminderMessage,
            });
            if (!res.error) {
                message.success('Reminder sent successfully');
            }
        } catch (error) {
            console.error(error);
        }
    };

    const reminderContent = (
        <>
            Send reminder <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M5.48511 6C5.85118 5.22321 6.83895 4.66667 8.00004 4.66667C9.4728 4.66667 10.6667 5.5621 10.6667 6.66667C10.6667 7.59963 9.81496 8.38338 8.66285 8.6044C8.30125 8.67377 8.00004 8.96514 8.00004 9.33333M8 11.3333H8.00667M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="#111827" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </>
    );

    return (
        <Popover
            content={renderInvoiceReminderPreview()}
            trigger="hover"
            placement="left"
            overlayClassName={s.invoiceReminderPopover}
        >
            {asButton ? (
                <Button className={s.reminderButton} onClick={handleSendReminder}>
                    <span className={s.popItem}>
                        {reminderContent}
                    </span>
                </Button>
            ) : (
                <div className={s.popItem} onClick={handleSendReminder}>
                    {reminderContent}
                </div>
            )}
        </Popover>
    );
};

export default InvoiceReminderBtn;
